import apiClient from 'services/httpClient'
import { API_ENDPOINTS } from 'shared/constants/apiEndpoints'

export async function getServices() {
    return apiClient.get({ url: API_ENDPOINTS.configs.services })
}
